import React from 'react';
import { Link } from 'react-router-dom';
import { DETAILS_PATH, STAGES_PATH } from '~/features/base/constants/routes';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { pathnameSelector } from '~/features/base/selectors/locationSelectors';
import { useSelector } from 'react-redux';
import { Campaign } from '~/api/models/campaign';

interface CampaignTabsProps {
    basePath: string;
    campaign: Campaign;
}

const renderNavigationItem = (basePath, view, label, campaign) => {
    const pathname = useSelector(pathnameSelector);
    const activeTab = pathname.split('/')?.[3];
    const className = {
        active: activeTab === view,
    }
    return (
        <li key={view} className={classNames(className)}>
            <Link to={{ pathname: `${basePath}/${view}`, state: { campaign } }}> <span
                className={'text-capitalize'}><FormattedMessage
                id={label}/></span></Link>
        </li>
    );
};
const renderNavigation = (props) => {
    const { basePath, campaign } = props;

    return (
        <ul className='nav nav-tabs user-select-none'>
            {renderNavigationItem(basePath, DETAILS_PATH, 'intl-msg:details', campaign)}
            {renderNavigationItem(basePath, STAGES_PATH, 'intl-msg:stage', campaign)}
            {/*{renderNavigationItem(basePath, HISTORY_PATH, 'intl-msg:history', campaign)}*/}
        </ul>
    );
};

const CampaignTabs: React.FC<CampaignTabsProps> = (props) => {
    const navigation = renderNavigation(props);

    return (
        <div className="campaign-nav row">
            <div className='col-md-12'>
                {navigation}
            </div>

        </div>
    );
};

export default CampaignTabs;
